/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext, useState } from 'react';

import { RouteNames } from 'pages/teach-course/constants';

import { Button, TemporaryDrawer, breakpoints } from '@coursera/cds-core';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import GraderModuleSaveButton from 'bundles/author-assignment-grading/components/common/components/GraderModuleSidebar/GraderModuleSaveButton';
import type LegacyTeam from 'bundles/author-assignment-grading/components/common/types/Team';
import type { SaveNotificationType } from 'bundles/author-assignment-grading/constants/SaveNotificationTypes';
import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import type { Learner } from 'bundles/grading/components/staff-graded-assignments/types/SGAGradingTypes';

import _t from 'i18n!nls/grading';

const styles = {
  primaryButton: () => css`
    ${breakpoints.down('xs')} {
      width: 100%;
      max-width: none;
    }
  `,
  secondaryButton: () => css`
    margin: 0 var(--cds-spacing-300) 0;
    ${breakpoints.down('xs')} {
      width: 100%;
      max-width: none;
      margin: var(--cds-spacing-300) 0 0;
    }
  `,
};

type Props = {
  onClose: () => void;
  setNotificationType: (notificationType: SaveNotificationType | null) => void;
  legacyTeam?: LegacyTeam;
};

// Component for Item Setting Exceptions Drawer's actions
const ActionsContainer: React.FC<Props> = ({ onClose, setNotificationType, legacyTeam }) => {
  const { pageData, submissionData } = useContext(SGAPageContext);
  const { Actions } = TemporaryDrawer;

  const [isSaving, setIsSaving] = useState(false);

  const userIdForSaveButton = submissionData.data?.isTeamAssignment
    ? legacyTeam?.members.find((memberUserId: number) => pageData.gradebookGrades[memberUserId]) ||
      legacyTeam?.members[0]
    : parseInt((submissionData.data?.submitter as Learner).userId, 10);

  return (
    <Actions>
      <GraderModuleSaveButton
        currentRoute={{ name: RouteNames.USER_EXCEPTION.assignment_grading_item }}
        gradingTabSelected={false}
        showConfirmationOnSave={false}
        userId={userIdForSaveButton}
        item={pageData.currentItem}
        sessionItem={pageData.sessionItem}
        team={legacyTeam}
        setSavingStatus={setIsSaving}
        overrideShowNotification={setNotificationType}
        inlineButton
        showSavingIcon
        cssOverride={styles.primaryButton}
      />
      <Button css={styles.secondaryButton} variant="secondary" onClick={onClose} disabled={isSaving}>
        {_t('Close')}
      </Button>
    </Actions>
  );
};

export default ActionsContainer;
